import React, { Component } from 'react';

import { replace as Replace, push as Push } from 'redux-first-history';
import { connect } from 'react-redux';
import RawEditor from 'react-monaco-editor';
import { compose } from 'react-recompose';
import { withRouter } from 'react-router';

import { Editor as EditorModule } from '@dev/ee-modules';
//interfaces
import { ApplicationState as State } from '@api/store';
import { ShowDialogParams } from '@api/store/dialog/types';
import { ChangeDefaultOptionsActionParams } from '@api/store/raweditor/types';
import { SingleContactStartLoading } from '@api/store/contacts/actions';

//actions in component
import {
    LoadTemplate,
    RedoTemplateChanges,
    UndoTemplateChanges,
    ChangeName,
    AddTag,
    RemoveTag,
    ModifyAMPBody,
    ModifyTextBody,
    ChangeFromName,
    ChangeFromEmail,
    ChangeSubject,
    ChangePreviewText,
    ChangeToEmail,
    SendTestEmail,
    ChangeTemplateBody,
    SavePastBody,
    ChangeDefaultOptions,
    CloseTemplateEditor,
    SaveScreenshot,
} from '@api/store/raweditor/actions';

import { ShowDialog, HideDialog, UpdateDialog } from '@api/store/dialog/actions';
import { ShowToast } from '@api/store/toast/actions';
import {
    ShowFileUpload,
    ShowMediaManager,
    HideMediaManager,
    ShowMediaManagerUploader,
    HideMediaManagerUploader,
} from '../../store/mediaManager/actions';
import { ResendActivationEmail } from '../../store/auth/actions';
import { DeleteFilesList, DeleteFile, LoadUserFiles } from '../../store/userfiles/actions';
import { UploadFilesMedia as UploadFiles } from '../../store/upload/actions';
import { FileType } from '../../store/mediaManager/types';
import { ShowToastParams } from '../../store/toast/types';
import { EditorProps } from './EditorInterface';
import { TemplatesPaths } from '@api/dashboards/Marketing/paths';
import { withTranslation } from 'react-i18next';
import { BillingPlanCategory } from '@dev/ee-api/ee-api-models';

declare const window: any;
declare const ee: any;

const monacoRawEditor = RawEditor;

const mapState = (state: State, ownProps: EditorProps): EditorProps => {
    return {
        ...ownProps,
        browser: state.browser,
        account: state.account,
        rawEditor: state.rawEditor,
        location: state.locationHistory.currentLocation,
        config: state.config,
        dialog: state.dialog,
        mediaManager: state.mediaManager,
        upload: state.upload,
        userFiles: state.userFiles,
        RawEditor: monacoRawEditor,
        validEmails: state.validEmails,
        products: state.products,
    };
};

interface DispatchProps {
    ChangeTemplateBody: (template: string) => void;
    LoadTemplate: (name: string, isNew: boolean, isPublic?: boolean) => void;
    RedoTemplateChanges: (previewRef: React.Ref<HTMLIFrameElement>) => void;
    UndoTemplateChanges: (previewRef: React.Ref<HTMLIFrameElement>) => void;
    ChangeName: (name: string, previewRef: React.Ref<HTMLIFrameElement>) => void;
    ShowDialog: (params: ShowDialogParams) => void;
    AddTag: (tag: string, previewRef: React.Ref<HTMLIFrameElement>) => void;
    RemoveTag: (tag: string, previewRef: React.Ref<HTMLIFrameElement>) => void;
    ModifyAMPBody: (body: string, previewRef: React.Ref<HTMLIFrameElement>) => void;
    ModifyTextBody: (body: string, previewRef: React.Ref<HTMLIFrameElement>) => void;
    ChangeFromName: (name: string, previewRef: React.Ref<HTMLIFrameElement>) => void;
    ChangeFromEmail: (email: string, previewRef: React.Ref<HTMLIFrameElement>) => void;
    ChangeSubject: (subject: string, previewRef: React.Ref<HTMLIFrameElement>) => void;
    ChangePreviewText: (previewText: string, previewRef: React.Ref<HTMLIFrameElement>) => void;
    ChangeToEmail: (email: string) => void;
    SendTestEmail: () => void;
    SavePastBody: (template: string, previewRef: React.Ref<HTMLIFrameElement>) => void;
    SaveScreenshot(previewRef: React.Ref<HTMLIFrameElement>): void;
    ChangeDefaultOptions: (params: ChangeDefaultOptionsActionParams) => void;
    HideDialog: () => void;
    UpdateDialog: (params: ShowDialogParams) => void;
    Replace: (url: string) => void;
    Push: (url: string) => void;
    CloseTemplateEditor: (previewRef: React.Ref<HTMLIFrameElement>) => void;
    ShowMediaManager: () => void;
    HideMediaManager: () => void;
    UploadFiles(file: File): void;
    LoadUserFiles(): void;
    DeleteFile(name: string, imageDelete: boolean): void;
    DeleteFilesList(filesList: string[], imagesDelete: boolean): void;
    ShowMediaManagerUploader(): void;
    HideMediaManagerUploader(): void;
    ShowFileUpload(file: FileType): void;
    ShowToast(params: ShowToastParams): void;
    SingleContactStartLoading(email: string, showErrorToast: boolean): void;
    ResendActivationEmail(params: { Email: string }): void;
}

const dispatchProps = {
    ShowDialog,
    LoadTemplate,
    ChangeTemplateBody,
    RedoTemplateChanges,
    UndoTemplateChanges,
    ChangeName,
    AddTag,
    RemoveTag,
    ModifyAMPBody,
    ModifyTextBody,
    ChangeFromName,
    ChangeFromEmail,
    ChangeSubject,
    ChangePreviewText,
    ChangeToEmail,
    SendTestEmail,
    SavePastBody,
    SaveScreenshot,
    ChangeDefaultOptions,
    HideDialog,
    Replace,
    Push,
    UpdateDialog,
    CloseTemplateEditor,
    ShowMediaManager,
    HideMediaManager,
    UploadFiles,
    LoadUserFiles,
    DeleteFile,
    DeleteFilesList,
    ShowMediaManagerUploader,
    HideMediaManagerUploader,
    ShowFileUpload,
    ShowToast,
    SingleContactStartLoading,
    ResendActivationEmail,
};

type ExtendedProps = EditorProps & DispatchProps;

class Editor extends Component<ExtendedProps> {
    topNavBar = document.getElementById('topnavbar');

    componentDidMount() {
        if (!this.props.config.isStandalone && this.topNavBar) {
            document.getElementById('econtent_wrapper')?.classList?.add('editor');
            this.topNavBar.hidden = true;
        }
    }

    componentWillUnmount() {
        if (!this.props.config.isStandalone && this.topNavBar) {
            document.getElementById('econtent_wrapper')?.classList?.remove('editor');
            this.topNavBar.hidden = false;
        }
    }

    render(): JSX.Element {
        const { GeneralInfo } = this.props?.account || {};
        const accountEmail = GeneralInfo?.UserName;
        const getApiPath = (): string => {
            if (!this.props.config.isStandalone && window.ee) {
                return ee.api.path;
            }

            return APIPATH;
        };
        //TODO: remove this after migration to multiproduct
        const apiPath = getApiPath();

        const { dashboards = [] } = this.props?.products || {};
        const isPilotPlan = dashboards?.[0]?.ActivePlanDetails?.Category === BillingPlanCategory.Pilot;

        return (
            <EditorModule
                APIPATH={apiPath}
                RawEditor={RawEditor}
                paths={TemplatesPaths}
                {...this.props}
                {...(isPilotPlan && {
                    inputsOverrides: {
                        sendTestTo: {
                            readOnly: true,
                            descriptionMessage: this.props.t('pilotplan_warning', { accountemail: accountEmail }),
                        },
                    },
                })}
            />
        );
    }
}
export default compose(withRouter, withTranslation(), connect<EditorProps, DispatchProps>(mapState, dispatchProps))(Editor);
